<template>
  <DetailsSkeleton v-if="!collectionDetails" />

  <div v-else>
    <div
      class="
        grid grid-cols-2
        layout-padding
        mt-[100px]
        h-full
        work-details-container
        py-[40px]
      "
    >
      <div
        class="
          col-span-2
          mt-5
          lg:mt-0
          order-last
          lg:order-first lg:col-span-1
          h-full
          flex flex-col
          justify-center
          text-section
        "
      >
        <div class="lg:text-4xl lg:leading-[50px] text-2xl">
          {{ collectionDetails?.data?.title }}
        </div>

        <div>
          <div class="text-lg font-bold mt-6">
            {{ content.artWorks }} / {{ content.collections }} /
            {{ collectionDetails?.data?.title }}
          </div>

          <!-- <div class="mt-12">Women Collection , 2004</div> -->
          <div
            class="mt-6 lg:w-10/12 w-full text-justify"
            v-html="collectionDetails?.data?.description"
          ></div>
        </div>
      </div>
      <div
        class="
          col-span-2
          order-first
          lg:order-last lg:col-span-1
          flex
          justify-center
        "
      >
        <img
          :src="collectionDetails?.data?.image"
          alt="slide"
          class="lg:max-h-[60vh] max-h-[40vh]"
        />
      </div>
    </div>
    <div
      class="layout-padding mb-24"
      v-if="collectionDetails?.data?.art_works.length > 0"
    >
      <div class="flex justify-between items-center my-8">
        <div class="lg:text-3xl text-2xl ltr:mr-2 rtl:ml-2">
          {{ content.paintings }}
        </div>

        <div
          class="
            lg:h-20
            h-12
            flex
            justify-between
            items-center
            text-3xl
            bg-primary
            w-max
            transition-all
            duration-700
            cursor-pointer
            lg:min-w-[216px]
            min-w-[120px]
          "
        >
          <div class="lg:px-8 px-4 lg:py-6 py-2 prev-painting-collection group">
            <img
              src="/static/images/icons/arrow-left.svg"
              alt="arrow-left "
              class="
                lg:w-8
                w-auto
                h-6
                md:ltr:ml-2 md:rtl:mr-2
                rtl:rotate-180
                md:group-hover:ml-0
                transition-all
                duration-300
              "
            />
          </div>
          <div class="lg:px-8 px-4 lg:py-6 py-2 next-painting-collection group">
            <img
              src="/static/images/icons/arrow-right.svg"
              class="
                lg:w-8
                w-auto
                h-6
                md:ltr:mr-2 md:rtl:ml-2
                rtl:rotate-180
                md:group-hover:mr-0
                transition-all
                duration-300
              "
              alt="arrow-left "
            />
          </div>
        </div>
      </div>
      <div class="mt-16">
        <swiper
          :breakpoints="breakpoints"
          :navigation="navigation"
          :loop="true"
        >
          <swiper-slide
            v-for="work in collectionDetails?.data?.art_works"
            :key="work.id"
          >
            <PaintingCard
              :work="work"
              :collectionTitle="collectionDetails?.data?.title"
              :collectionYear="collectionDetails?.data?.year"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import PaintingCard from "/src/components/UI/Cards/PaintingCard.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore from "swiper";
import { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
SwiperCore.use([Navigation]);
export default {
  props: ["id"],
  inject: ["content"],
  data() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      navigation: {
        nextEl: ".next-painting-collection",
        prevEl: ".prev-painting-collection",
      },
    };
  },
  computed: {
    collectionDetails() {
      return this.$store.getters["collections/collectionDetails"];
    },
  },
  components: {
    PaintingCard,
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.$store.dispatch("collections/collectionDetails", this.id);
  },
  unmounted() {
    this.$store.dispatch("collections/resetCollectionDetails");
  },
};
</script>